import StatusPill, { type Tone } from '@/components/console/status-pill';
import type { ProviderMode } from '@/types/platform';

const LABELS: Record<ProviderMode, { text: string; tone: Tone }> = {
  live: { text: 'Live', tone: 'success' },
  demo: { text: 'Demo', tone: 'warning' },
  unconfigured: { text: 'Not connected', tone: 'danger' },
};

// Whether a platform service is real, a stand-in, or missing its keys.
export default function ModeBadge({ mode }: { mode: ProviderMode }) {
  const { text, tone } = LABELS[mode];

  return <StatusPill tone={tone}>{text}</StatusPill>;
}
